import path from 'node:path';
import { DASHBOARD_PLUGINS_DIR } from '@wix/cli-app-definitions';
import type { DevCenterComponent } from '../dev-center-component.js';
import { composeValidations, pathValidation } from './common.js';

function dashboardPluginExistsValidation(
  existingDashboardPlugins: Array<DevCenterComponent<'DashboardPlugin'>>
) {
  return (folder: string) =>
    existingDashboardPlugins.every((dashboardPlugin) => {
      const pluginRelativePath = path.relative(
        DASHBOARD_PLUGINS_DIR,
        dashboardPlugin.relativePath
      );

      const pluginName = path.dirname(pluginRelativePath);

      return folder !== pluginName;
    });
}

export function createDashboardPluginValidation(
  dashboardPlugins: Array<DevCenterComponent<'DashboardPlugin'>>
) {
  return composeValidations([
    [
      dashboardPluginExistsValidation(dashboardPlugins),
      'The plugin folder must be unique, please choose a name that has not been used yet in your application.',
    ],
    [
      pathValidation,
      'The plugin folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
